import React from 'react';
import FilteredRequest from './FilteredRequest';

const Count = ({ imgSrc, imgDescription, route }) => (
  <FilteredRequest url={route}>
    {({ data, loading }) => (
      <div className="DataCard-count">
        <img src={imgSrc} alt={imgDescription} />
        {!loading && data ? data.count.toLocaleString() : '…'}
      </div>
    )}
  </FilteredRequest>
);

export default Count;
